import { render, staticRenderFns } from "./App.vue?vue&type=template&id=aed56fe2&"
import script from "./App.vue?vue&type=script&lang=ts&"
export * from "./App.vue?vue&type=script&lang=ts&"
import style0 from "vue-flash-message/dist/vue-flash-message.min.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/scss/style.scss?vue&type=style&index=1&lang=scss&"
import style2 from "./App.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VFadeTransition,VMain})
